import { UnscheduledSectionsByCampus } from '../../views/unscheduled_sections/components/unscheduled_sections_by_campus/unscheduled_sections_by_campus';

export class SearchResultsList extends UnscheduledSectionsByCampus {}
angular.module('capability-ng-scheduler').component('searchResultsList', {
  templateUrl: 'capability-ng-scheduler/src/components/crn_search/search_results_list.html',
  controller: UnscheduledSectionsByCampus,
  bindings: {
    results: '<',
    searchKeyword: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/crn_search/search_results_list.ts